const rfcFormatter = (value) => (
  value ? value.toString().toUpperCase() : ''
);

export default rfcFormatter;
